import React, { useState } from "react";
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle, Input, Badge } from "reactstrap";

export function SearchableSelect({
    data, 
    onChange, 
    placeholder, 
    disabled, 
    value, 
    isMultiSelect = false,
    valueField = "value",   // Properti default untuk value, dapat disesuaikan
    labelField = "label",
    showBadges = true,   // Properti default untuk label, dapat disesuaikan
}) {
    const [open, setOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedValues, setSelectedValues] = useState(value || []); // Menangani pemilihan nilai berdasarkan props 'value'

    const toggleDropdown = () => {
        if (!disabled) {
            setOpen(!open); // Hanya toggle dropdown jika tidak disabled
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);  // Update search query saat mengetik
    };

    const handleSelect = (selectedValue) => {
        if (isMultiSelect) {
            // Cek jika item yang sama diklik kembali
            if (selectedValues.includes(selectedValue)) {
                // Jika sudah ada, hapus dari selectedValues
                setSelectedValues(selectedValues.filter((item) => item !== selectedValue));
            } else {
                // Tambahkan ke selectedValues
                setSelectedValues((prev) => [...prev, selectedValue]);
            }
        } else {
            // Untuk single select, jika sudah dipilih, reset
            if (selectedValues[0] === selectedValue) {
                setSelectedValues([]); // Menghapus nilai yang sudah dipilih
            } else {
                setSelectedValues([selectedValue]);
            }
        }

        if (Array.isArray(data)) {
            // Mencari item yang dipilih berdasarkan field yang dinamis
            const selectedItem = data.find((item) => item[valueField] === selectedValue);

            // Mengirimkan nilai berdasarkan field dinamis (valueField dan labelField)
            onChange(selectedItem ? selectedItem[valueField] : selectedValue);  // Mengirimkan nilai yang dipilih
        }
    };


    // Filter data berdasarkan searchQuery
    const filteredData = searchQuery === "" ? data : data.filter((item) =>
        item[labelField] && item[labelField].toLowerCase().includes(searchQuery.toLowerCase())  // Memastikan 'labelField' ada sebelum memanggil toLowerCase
    );

    console.log("Filtered Data:", filteredData); // Debugging data yang difilter
    console.log("Data received in SearchableSelect:", data);  // Memeriksa data yang diterima
    console.log("Search query:", searchQuery);  // Memeriksa nilai searchQuery

    return (
        <div className="relative">
            <Dropdown isOpen={open} toggle={toggleDropdown}>
                <DropdownToggle className="w-100 text-truncate" outline caret>
                    {selectedValues.length > 0
                        ? selectedValues.map((value) => data.find((item) => item.value === value)?.label).join(", ")
                        : placeholder || "Select items..."}
                </DropdownToggle>
                <DropdownMenu className="w-100 p-2 overflow-auto" style={{ maxHeight: "300px" }}>
                    <Input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        disabled={disabled}
                        className="mb-2"
                    />
                    {filteredData.length === 0 ? (
                        <DropdownItem disabled>No item found.</DropdownItem>
                    ) : (
                        filteredData.map((item) => (
                            <DropdownItem
                                key={item.value}
                                onClick={() => handleSelect(item.value)}
                                active={selectedValues.includes(item.value)}
                            >
                                {item.label}
                                {selectedValues.includes(item.value) && <span className="ms-2">✔</span>}
                            </DropdownItem>
                        ))
                    )}
                </DropdownMenu>
            </Dropdown>

            {/* Tampilkan Badge untuk item yang dipilih */}
            {showBadges && (
                <div className="selected-items mt-2">
                    {selectedValues.length > 0 && (
                        <div>
                            {selectedValues.map((selectedValue) => (
                                <Badge key={selectedValue} color="primary" className="me-2">
                                    {data.find((item) => item[valueField] === selectedValue)?.[labelField]}
                                    <span
                                        className="ms-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setSelectedValues(selectedValues.filter((item) => item !== selectedValue));
                                            onChange(selectedValues);  // Update pilihan setelah menghapus
                                        }}
                                    >
                                        &times;
                                    </span>
                                </Badge>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default SearchableSelect;

